import { apiRequest, USE_MOCKS } from './client'
import type { EventListResponse } from '@/types'
import { mockEvents } from '@/mocks/events'

export async function listEvents(params?: {
  node_id?: string
  level?: string
  command_id?: string
  since?: string
  limit?: number
  offset?: number
}): Promise<EventListResponse> {
  if (USE_MOCKS) return mockEvents(params)
  const qs = new URLSearchParams()
  if (params?.node_id) qs.set('node_id', params.node_id)
  if (params?.level) qs.set('level', params.level)
  if (params?.command_id) qs.set('command_id', params.command_id)
  if (params?.since) qs.set('since', params.since)
  if (params?.limit != null) qs.set('limit', String(params.limit))
  if (params?.offset != null) qs.set('offset', String(params.offset))
  const query = qs.toString() ? `?${qs}` : ''
  return apiRequest<EventListResponse>(`/api/events${query}`)
}
